import { Flow_0_0_2 } from '@flexus/core';

export const BET_18: Flow_0_0_2 = {
	id: '18',
	name: 'claim_reopened',
	itemType: 'flow',
	header: {
		title: 'Claim Submitted',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Placeholder'
		},
		viewRoles: {
			0: 'Placeholder'
		}
	},
	startNode: '',
	nodes: {}
};
